import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import WithRender from './Country.html';


@WithRender
@Component({
    components: {
    },
    computed: {
        ...mapGetters("originatorStore", { originator: "getOriginator"}),
    }
})
export default class Country extends Vue {
    originator!: string;
    countries = [
        { id: 'zw', img: 'img/flags/zw.png', name: 'Zimbabwe' },
        { id: 'mw', img: 'img/flags/malawi.png', name: 'Malawi' },
        { id: 'za', img: 'img/flags/sa.png', name: 'South Africa'},
        // { id: 'bu', img: 'img/logo/bus_yellow.png', name: 'Rimbi Bus Tickets'},
        { id: 'fp', img: 'img/logo/money.png', name: 'Request Payment'}
    ];
    selectedCountry = 'zw';

    mounted() {
        if (this.originator == "mw")
            this.$router.push({ name: 'products', query: { c: "mw" } });
    }

    proceed(id:string):string
    {
        let route ="";        
        if(id =="bu")
        route = `busticket?portiFolio=bus-ticket&c=za`
        if(id =="fp")
        route =`flexipay`;
        else
        route = `products?c=${id}`
        return route;
    }
}
